import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/brand.css';
import './styles/modalSystem.css';
import './styles/retroAccents.css';
import App from './App';
import { installLogoBalance } from './utils/logoBalance';
import reportWebVitals from './reportWebVitals';

// Silence chatty/diagnostic console output in production so we never leak data
// (customer info, full record dumps) to the browser console. Warnings and errors
// are kept for real diagnostics.
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = () => {};
  // eslint-disable-next-line no-console
  console.debug = () => {};
  // eslint-disable-next-line no-console
  console.info = () => {};
}

// Recover from stale-deploy chunk failures: when a new build is deployed while a
// tab is open, its lazy JS/CSS chunk hashes change and the old ones 404. Reload
// once (throttled to avoid loops) so the user transparently gets the new build.
(() => {
  const isChunkError = (msg: string) =>
    /Loading (CSS )?chunk [\w-]+ failed|ChunkLoadError|error loading dynamically imported module|Failed to fetch dynamically imported module/i.test(
      msg
    );
  const recover = (msg: string) => {
    if (!isChunkError(msg)) return;
    try {
      const last = Number(sessionStorage.getItem('chunkReloadAt') || 0);
      if (Date.now() - last > 10000) {
        sessionStorage.setItem('chunkReloadAt', String(Date.now()));
        window.location.reload();
      }
    } catch {
      window.location.reload();
    }
  };
  window.addEventListener(
    'error',
    (e: any) => recover(String(e?.message || e?.error?.message || '')),
    true
  );
  window.addEventListener('unhandledrejection', (e: any) =>
    recover(String(e?.reason?.message || e?.reason || ''))
  );
})();

installLogoBalance();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();